import React from 'react';

function ScoreBar({ score, label, small }) {
  if (score === null || score === undefined) return null;

  const color =
    score >= 70 ? '#22c55e' :
    score >= 50 ? '#f59e0b' :
    score >= 30 ? '#f97316' : '#ef4444';

  const height = small ? 6 : 10;
  const fontSize = small ? '0.75rem' : '0.85rem';

  return (
    <div style={{ marginBottom: small ? 4 : 8 }}>
      {label && (
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize, marginBottom: 2 }}>
          <span style={{ color: '#6b7280' }}>{label}</span>
          <span style={{ fontWeight: 600, color }}>{score}%</span>
        </div>
      )}
      <div style={{ background: '#e5e7eb', borderRadius: 999, height, overflow: 'hidden' }}>
        <div style={{
          width: `${Math.min(score, 100)}%`,
          height: '100%',
          background: color,
          borderRadius: 999,
          transition: 'width 0.5s ease',
        }} />
      </div>
    </div>
  );
}

export default ScoreBar;
